import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Card,
  CardContent,
  Grid,
  Tooltip,
  TableFooter,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Alert,
  TablePagination,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  LinearProgress,
  Snackbar,
  CardHeader,
  TableSortLabel,
  SelectChangeEvent,
  Container,
  Input,
  OutlinedInput,
  InputBase,
} from "@mui/material";
import {
  Search,
  Close,
  Person,
  Payment,
  Receipt,
  AccountBalance,
  Warning,
  ArrowForward,
  Visibility,
  CheckCircle,
  AttachMoney,
  Description,
  AttachFile,
  ZoomIn,
  FilterList,
  Download,
  ExpandMore,
  ExpandLess,
  Refresh,
  Info as InfoIcon,
  Error as ErrorIcon,
  LocalShipping,
  Store,
  Category,
  Inventory,
  AccountCircle,
  Phone,
  Email,
  LocationOn,
  CreditCard,
  MonetizationOn,
  TrendingUp,
  TrendingDown,
  CalendarToday,
  AccessTime,
  Print,
  Share,
  MoreVert,
  ArrowDropDown,
  ArrowDropUp,
  BarChart,
  PieChart,
  ShowChart,
  Assessment,
  Dashboard,
  ViewList,
  ViewModule,
  ViewCompact,
  FilterAlt,
  Sort,
  Tune,
  ClearAll,
  SaveAlt,
  PictureAsPdf,
  GridView,
  ListAlt,
  TableChart,
  Add,
  Remove,
  Delete,
  Edit,
  ContentCopy,
  FileCopy,
  GetApp,
  Upload,
  CloudUpload,
  CloudDownload,
  Sync,
  Autorenew,
  Cached,
  RotateLeft,
  RotateRight,
  ZoomOut,
  Fullscreen,
  FullscreenExit,
  OpenInNew,
  Launch,
  Link,
  InsertLink,
  InsertPhoto,
  InsertDriveFile,
  Attachment,
  Cloud,
  Storage,
  Database,
  DataUsage,
  Memory,
  DeveloperBoard,
  IntegrationInstructions,
  Api,
  Web,
  Android,
  Apple,
  Windows,
  Linux,
  Devices,
  Computer,
  Laptop,
  Tablet,
  PhoneAndroid,
  PhoneIphone,
  Smartphone,
  Watch,
  Headset,
  Keyboard,
  Mouse,
  Speaker,
  Tv,
  CameraAlt,
  Videocam,
  Mic,
  Headphones,
  Power,
  BatteryFull,
  BatteryChargingFull,
  BatteryStd,
  BatteryUnknown,
  BatteryAlert,
  BatteryVeryLow,
  BatteryLow,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatterySaver,
  PowerOff,
  PowerSettingsNew,
  RestartAlt,
  Settings,
  SettingsApplications,
  SettingsBackupRestore,
  SettingsBluetooth,
  SettingsBrightness,
  SettingsCell,
  SettingsEthernet,
  SettingsInputAntenna,
  SettingsInputComponent,
  SettingsInputComposite,
  SettingsInputHdmi,
  SettingsInputSvideo,
  SettingsOverscan,
  SettingsPhone,
  SettingsRemote,
  SettingsVoice,
  Build,
  BuildCircle,
  Engineering,
  Handyman,
  Plumbing,
  ElectricalServices,
  Carpenter,
} from "@mui/icons-material";
import { formatCurrencyN } from "../../../common/utils_t";
import {
  getAllCustomers2,
  getCustomersWithPendingTransactions,
  getCustomersWithPendingTransactions_crm,
  getCustomersWithPendingTransactions_crm_admin,
} from "../../../api/customers/customers";
import { IonApp, IonButton, IonContent, IonPage } from "@ionic/react";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { fetchSalesData_withdate_staffId_paymentMethodCall, getManagersOrders_reciept, getManagersOrders_reciept_withdate, getOrderTransaction, verifyTransaction, fetchOrderDetails_items } from "../../../api/reports/reports";
import { getStaffList_saleapp } from "../../../api/users/user";
import { baseUrl } from "../../../common/utils";
import { MenuButton } from "../../../components/Menu";
import { getCategories } from "../../../api/products/product"; // Add this import

interface Customer {
  id: string;
  user_id: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  grade_letter: string;
}

interface PendingTransactionSummary {
  customer_id: string;
  total_outstanding: number;
  transaction_count: number;
  customer: Customer;
  member_name: string;
  customer_phone: string;
  customer_email: string;
  balance_due: number;
  // ADD TRANSACTION FIELDS HERE
  order_id?: string;
  order_code?: string;
  order_date?: string;
  mode_of_payment?: string;
  payable_amount?: string;
  amount_paid?: string;
  order_status?: string;
  product_id_type?: string;
  is_verified?: number;
  is_audited?: number;
  // Additional fields for verification dialog
  customer_name?: string;
  customer_account_name?: string;
  customer_account_number?: string;
  bank_name?: string;
  active_status?: string;
  staff_name?: string;
  mode_of_payment_real?: string;
  card_amount?: string;
  rmbValue?: string;
  cryptoType?: string;
  cryptoAmount?: string;
  costPrice?: string;
  sellingPrice?: string;
  commission?: string;
  external_processor?: string;
  processor_type?: string;
  processor_category?: string;
  load_type?: string;
  card_rate?: string;
  naira_rate?: string;
  internal_rate?: string;
  created_at?: string;
  last_updated?: string;
  proof_of_payment?: string;
  proof_of_jobstart?: string;
  crypto_value?: string;
  images?: string[];
  screenshot?: string;
  transaction_proof?: string;
  branch_id?: string;
  order_by?: string;
  giftcardType?: string;
  cardUnit?: number;
  payment_status?: number;
  member_id?: string;
  transaction_category?: string; // Add transaction_category field
}

interface OrderItem {
  product_id: string;
  quantity: string;
  product_name: string;
  price: string;
  total_amount: string;
  item_status: string;
  name?: string;
  description?: string;
  category_id?: string;
  cost_price?: string;
  status?: string;
  business_id?: string;
}

interface SalesStats {
  total_sales: number;
  total_orders: number;
  average_order_value: number;
  top_payment_method: string;
  growth_percentage: number;
  pending_orders: number;
  completed_orders: number;
}

interface Staff {
  staff_id: string;
  staff_name: string;
  user_id: string;
  firstName: string;
  lastName: string;
}

interface ProductCategory {
  category_id: string;
  name: string;
  description?: string;
  status?: string;
}

interface FilterState {
  startDate: Date | null;
  endDate: Date | null;
  paymentMethod: string;
  department: string;
  orderStatus: string;
  paymentStatus: string;
  staffId: string;
  productType: string;
  categoryId: string; // Add category filter
}

// Interface for Order Details Response
interface OrderDetailsResponse {
  success: boolean;
  data: {
    order_id: string;
    order_code: string;
    order_date: string;
    items: OrderItem[];
    subtotal: number;
    tax: number;
    discount: number;
    total: number;
    payment_method: string;
    staff_name: string;
    customer_name: string;
    date_range?: {
      applied: boolean;
      start_date: string;
      end_date: string;
    };
  };
  message?: string;
  status?: boolean;
}

const CustomerAccountPage_pending_admin_view: React.FC = () => {
  const history = useHistory();
  const [allCustomers, setAllCustomers] = useState<Customer[]>([]);
  const [pendingTransactions, setPendingTransactions] = useState<PendingTransactionSummary[]>([]);
  const [filteredPending, setFilteredPending] = useState<PendingTransactionSummary[]>([]);
  const [loading, setLoading] = useState({
    customers: false,
    pending: false,
  });
  const [searchQuery, setSearchQuery] = useState("");

  // NEW STATE VARIABLES FOR DIALOG AND FILTERS
  const [showFilters, setShowFilters] = useState(false);
  const [verifyDialogOpen, setVerifyDialogOpen] = useState(false);
  const [transactionToVerify, setTransactionToVerify] = useState<PendingTransactionSummary | null>(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const [verifyDialogLoading, setVerifyDialogLoading] = useState(false);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // NEW STATE FOR AUTO REFRESH
  const [isAutoRefreshing, setIsAutoRefreshing] = useState(false);
  const [lastRefreshTime, setLastRefreshTime] = useState<Date>(new Date());
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(true);
  const [refreshCount, setRefreshCount] = useState(0);

  // NEW STATE FOR ORDER DETAILS DIALOG (from second component)
  const [showTransactionDetail, setShowTransactionDetail] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<PendingTransactionSummary | null>(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [orderDetails, setOrderDetails] = useState<OrderDetailsResponse['data'] | null>(null);
  const [detailsError, setDetailsError] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const [staffList, setStaffList] = useState<Staff[]>([]);
  const [categories, setCategories] = useState<ProductCategory[]>([]); // Add categories state
  
  const [filters, setFilters] = useState<FilterState>({
    startDate: dayjs().toDate(),
    endDate: dayjs().toDate(),
    paymentMethod: "",
    department: "",
    orderStatus: "",
    paymentStatus: "",
    staffId: "",
    productType: "",
    categoryId: "", // Initialize category filter
  });

  const paymentMethods = ["All", "manual_transfer", "auto_transfer"];
  const orderStatuses = ["All", "COMPLETED", "PENDING", "CANCELLED"];
  const paymentStatuses = ["All", "0", "1", "2"];

  // Use refs to prevent stale closures in intervals
  const autoRefreshEnabledRef = useRef(autoRefreshEnabled);
  const verifyDialogOpenRef = useRef(verifyDialogOpen);
  
  // Update refs when state changes
  useEffect(() => {
    autoRefreshEnabledRef.current = autoRefreshEnabled;
    verifyDialogOpenRef.current = verifyDialogOpen;
  }, [autoRefreshEnabled, verifyDialogOpen]);

  // Fetch all data on component mount
  useEffect(() => {
    fetchAllCustomers();
    fetchPendingTransactions_admin();
    fetchStaffData();
    fetchCategories(); // Fetch categories
    
    // Set up auto-refresh
    const intervalId = setInterval(() => {
      // Only refresh if auto-refresh is enabled AND no dialog is open
      if (autoRefreshEnabledRef.current && !verifyDialogOpenRef.current) {
        fetchPendingTransactionsQuietly();
      }
    }, 300000); // 8 seconds

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  // Apply filters when search changes
  useEffect(() => {
    applyFilters();
  }, [searchQuery, filters, pendingTransactions]);

  // Fetch all customers
  const fetchAllCustomers = async () => {
    try {
      setLoading((prev) => ({ ...prev, customers: true }));
      const response = await getAllCustomers2();
      setAllCustomers(response.data);
    } catch (error) {
      console.error("Error fetching all customers:", error);
    } finally {
      setLoading((prev) => ({ ...prev, customers: false }));
    }
  };

  // Fetch categories data
  const fetchCategories = async () => {
    try {
      const response = await getCategories();
      console.log("Categories response:", response);
      if (response.data) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch categories", error);
      setSnackbarMessage("Failed to fetch categories");
      setSnackbarOpen(true);
    }
  };

  // Main fetch function - for manual calls
  const fetchPendingTransactions_admin = async () => {
    try {
      setLoading((prev) => ({ ...prev, pending: true }));
      const response = await getCustomersWithPendingTransactions_crm_admin();
      console.log("Fetched pending transactions:", response.data);
      
      // Transform the data to include transaction details
      const transformedData = response.data.orders.map((item: any) => ({
        ...item,
        // Map transaction fields if they exist in the response
        order_id: item.order_id || item.transaction_id || "",
        order_code: item.order_code || "N/A",
        order_date: item.order_date || item.created_at || "",
        mode_of_payment: item.mode_of_payment || "N/A",
        payable_amount: item.payable_amount || "0",
        amount_paid: item.amount_paid || "0",
        order_status: item.order_status || "PENDING",
        product_id_type: item.product_id_type || "N/A",
        is_verified: item.is_verified || 0,
        is_audited: item.is_audited || 0,
        // Map customer fields
        customer_name: item.member_name || "",
        customer_phone: item.customer_phone || "",
        customer_email: item.customer_email || "",
        // Map category if available
        transaction_category: item.transaction_category || item.category_id || "",
      }));
      
      setPendingTransactions(transformedData);
      setFilteredPending(transformedData);
      setLastRefreshTime(new Date());
    } catch (error) {
      console.error("Error fetching pending transactions:", error);
    } finally {
      setLoading((prev) => ({ ...prev, pending: false }));
    }
  };

  // Quiet fetch function - for auto-refresh (no loading indicators)
  const fetchPendingTransactionsQuietly = async () => {
    // Skip if already refreshing or dialog is open
    if (isAutoRefreshing || verifyDialogOpenRef.current) return;
    
    try {
      setIsAutoRefreshing(true);
      const response = await getCustomersWithPendingTransactions_crm();
      console.log("Auto-refreshed pending transactions:", response.data);
      
      // Transform the data to include transaction details
      const transformedData = response.data.orders.map((item: any) => ({
        ...item,
        // Map transaction fields if they exist in the response
        order_id: item.order_id || item.transaction_id || "",
        order_code: item.order_code || "N/A",
        order_date: item.order_date || item.created_at || "",
        mode_of_payment: item.mode_of_payment || "N/A",
        payable_amount: item.payable_amount || "0",
        amount_paid: item.amount_paid || "0",
        order_status: item.order_status || "PENDING",
        product_id_type: item.product_id_type || "N/A",
        is_verified: item.is_verified || 0,
        is_audited: item.is_audited || 0,
        // Map customer fields
        customer_name: item.member_name || "",
        customer_phone: item.customer_phone || "",
        customer_email: item.customer_email || "",
        // Map category if available
        transaction_category: item.transaction_category || item.category_id || "",
      }));
      
      setPendingTransactions(transformedData);
      setFilteredPending(transformedData);
      setLastRefreshTime(new Date());
      setRefreshCount(prev => prev + 1);
    } catch (error) {
      console.error("Error during auto-refresh:", error);
    } finally {
      setIsAutoRefreshing(false);
    }
  };

  // Fetch staff data
  const fetchStaffData = async () => {
    try {
      const response = await getStaffList_saleapp();
      console.log({ staffResponse: response });
      if (response.data) {
        setStaffList(response.data);
      }
    } catch (error) {
      console.error("Error fetching staff data:", error);
    }
  };

  // NEW FUNCTION: Fetch order details from API endpoint
  const fetchOrderDetails = async (orderId: string, branchId?: string) => {
    setLoadingDetails(true);
    setDetailsError(null);
    setOrderDetails(null);

    try {
      console.log("Fetching order details for:", {
        order_id: orderId,
        branch_id: branchId
      });

      const response = await fetchOrderDetails_items(orderId, "", "", branchId || "");
      console.log({ response });

      if (response.status) {
        setOrderDetails(response.data);
        setSnackbarMessage("Order details loaded successfully");
        setSnackbarOpen(true);
      } else {
        throw new Error(response.message || "Failed to load order details");
      }

    } catch (error) {
      console.error("Error fetching order details:", error);
      setDetailsError(error instanceof Error ? error.message : "Failed to load order details");
      setSnackbarMessage("Failed to load order details");
      setSnackbarOpen(true);
    } finally {
      setLoadingDetails(false);
    }
  };

  // MODIFIED: Update viewTransactionDetail to fetch order details
  const viewTransactionDetail = async (transaction: PendingTransactionSummary) => {
    console.log("transaction", transaction);
    setSelectedTransaction(transaction);
    setShowTransactionDetail(true);
    
    // Fetch order details when dialog opens
    await fetchOrderDetails(transaction.order_id || "", transaction.branch_id);
  };

  // NEW: Close dialog and reset details
  const closeTransactionDetail = () => {
    setShowTransactionDetail(false);
    setSelectedTransaction(null);
    setOrderDetails(null);
    setDetailsError(null);
  };

  // Filter transactions
  const applyFilters = () => {
    let filtered = pendingTransactions || [];

    // Apply search filter
    if (searchQuery) {
      filtered = filtered?.filter(
        (transaction) =>
          transaction?.order_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          transaction?.member_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          transaction?.customer_phone?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          transaction?.customer_email?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (filters.startDate && filters.endDate) {
      const start = new Date(filters.startDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(filters.endDate);
      end.setHours(23, 59, 59, 999);

      filtered = filtered?.filter((transaction) => {
        if (!transaction?.order_date) return false;
        const transactionDate = new Date(transaction.order_date);
        return transactionDate >= start && transactionDate <= end;
      });
    }

    // Apply payment method filter
    if (filters.paymentMethod && filters.paymentMethod !== "All") {
      filtered = filtered?.filter(
        (transaction) => transaction?.mode_of_payment === filters.paymentMethod
      );
    }

    // Apply order status filter
    if (filters.orderStatus && filters.orderStatus !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.order_status === filters.orderStatus);
    }

    // Apply staff filter
    if (filters.staffId && filters.staffId !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.order_by === filters.staffId);
    }

    // Apply product type filter
    if (filters.productType && filters.productType !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.product_id_type === filters.productType);
    }

    // Apply category filter
    if (filters.categoryId && filters.categoryId !== "") {
      filtered = filtered?.filter((transaction) => transaction?.transaction_category === filters.categoryId);
    }

    setFilteredPending(filtered);
  };

  const handleFilterChange = (field: keyof FilterState, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle category change
  const handleCategoryChange = (categoryId: string) => {
    handleFilterChange("categoryId", categoryId);
  };

  const clearFilters = () => {
    setFilters({
      startDate: dayjs().toDate(),
      endDate: dayjs().toDate(),
      paymentMethod: "",
      department: "",
      orderStatus: "",
      paymentStatus: "",
      staffId: "",
      productType: "",
      categoryId: "", // Reset category filter
    });
    setSearchQuery("");
  };

  // Toggle auto-refresh
  const toggleAutoRefresh = () => {
    setAutoRefreshEnabled(prev => !prev);
  };

  // Manual refresh function
  const handleManualRefresh = () => {
    fetchPendingTransactions_admin();
  };

  // Verification dialog functions
  const handleVerifyClick = async (transaction: PendingTransactionSummary) => {
    setVerifyDialogOpen(true);
    setVerifyDialogLoading(true);

    try {
      // First, get full transaction details
      const transactionToFetch = {
        order_code: transaction.order_code,
        order_id: transaction.order_id,
        member_id: transaction.customer_id,
      };
      
      const response = await getOrderTransaction(transactionToFetch);
      console.log("Transaction details:", response.data);

      if (response.status) {
        // Merge the fetched details with the existing transaction
        setTransactionToVerify({
          ...transaction,
          ...response.data
        });
      } else {
        // If API fails, use the basic transaction data
        setTransactionToVerify(transaction);
      }
    } catch (error) {
      console.error("Error fetching transaction details:", error);
      // Use the basic transaction data if API fails
      setTransactionToVerify(transaction);
    } finally {
      setTimeout(() => {
        setVerifyDialogLoading(false);
      }, 500);
    }
  };

  const handleVerifyTransaction = async () => {
    if (!transactionToVerify) return;
    console.log(transactionToVerify.order_code);
    setIsVerifying(true);
    try {
      const response = await verifyTransaction(transactionToVerify);
      // Refresh the data after verification
      fetchPendingTransactions();
    } catch (error) {
      console.error("Error verifying transaction:", error);
      alert("An error occurred during verification.");
    } finally {
      setIsVerifying(false);
      setVerifyDialogOpen(false);
      setTransactionToVerify(null);
    }
  };

  const handleImageClick = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setImageDialogOpen(true);
  };

  const getOrderStatusColor = (status: string) => {
    if (!status) return "default";
    switch (status.toUpperCase()) {
      case "COMPLETED":
        return "error";
      case "PENDING":
        return "warning";
      case "CANCELLED":
        return "error";
      default:
        return "default";
    }
  };

  const getPaymentStatusLabel = (status: string) => {
    switch (status) {
      case "0":
        return "Unpaid";
      case "1":
        return "Paid";
      case "2":
        return "Partial";
      default:
        return "Unknown";
    }
  };

  const getPaymentStatusColor = (status: string) => {
    switch (status) {
      case "0":
        return "error";
      case "1":
        return "success";
      case "2":
        return "warning";
      default:
        return "default";
    }
  };

  const formatCurrency = (amount: string | number) => {
    const numAmount = typeof amount === "string" ? Number.parseFloat(amount) : amount;
    if (isNaN(numAmount)) return "₦0.00";
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(numAmount);
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "Invalid Date";
    try {
      return new Date(dateString).toLocaleDateString("en-NG", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      return "Invalid Date";
    }
  };

  const formatTimeAgo = (date: Date) => {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    
    if (diffSec < 60) return `${diffSec} seconds ago`;
    if (diffSec < 3600) return `${Math.floor(diffSec / 60)} minutes ago`;
    return `${Math.floor(diffSec / 3600)} hours ago`;
  };

  const handleCustomerSelect = (selectedCustomer: PendingTransactionSummary) => {
    const selectedCustomerx: Customer = {
      id: selectedCustomer.member_id || selectedCustomer.customer_id || "",
      user_id: selectedCustomer.member_id || selectedCustomer.customer_id || "",
      firstName: selectedCustomer.member_name || "",
      lastName: "",
      phone: selectedCustomer.customer_phone || "",
      email: selectedCustomer.customer_email || "",
      grade_letter: "A",
    };
    console.log("Selected customer:", selectedCustomerx);

    history.push("/folder/raise-receipt/:name", { customer: selectedCustomerx });
  };

  const handleViewAllCustomers = () => {
    history.push("/folder/customer-accounts-giftcard-crypto");
  };

  const getOutstandingColor = (amount: number) => {
    if (amount > 50000) return "error";
    if (amount > 20000) return "warning";
    return "primary";
  };

   const getOutstandingColor2 = (amount: number) => {
    if (amount > 1) return "error";
    if (amount > 1) return "warning";
    return "error";
  };

  // Calculate totals for pending transactions
  const totalOutstanding = filteredPending.reduce(
    (sum, item) => sum + Number(item.balance_due),
    0
  );
  const totalCustomers = filteredPending.length;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <IonPage className="pushDown">
        <MenuButton/>
        
        <IonContent>
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h4" gutterBottom>
                Pending Transactions
              </Typography>
              
              {/* Auto-refresh indicator and controls */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  {autoRefreshEnabled ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <CircularProgress size={12} />
                      <span>Auto-refresh enabled</span>
                    </Box>
                  ) : (
                    "Auto-refresh paused"
                  )}
                </Typography>
                
                <Tooltip title={autoRefreshEnabled ? "Pause auto-refresh" : "Enable auto-refresh"}>
                  <IconButton 
                    size="small" 
                    onClick={toggleAutoRefresh}
                    color={autoRefreshEnabled ? "primary" : "default"}
                  >
                    <Refresh />
                  </IconButton>
                </Tooltip>
                
                <Tooltip title="Refresh now">
                  <IconButton 
                    size="small" 
                    onClick={handleManualRefresh}
                    disabled={loading.pending}
                  >
                    {loading.pending ? <CircularProgress size={20} /> : <Refresh />}
                  </IconButton>
                </Tooltip>
                
                <Typography variant="caption" color="text.secondary">
                  Last updated: {formatTimeAgo(lastRefreshTime)}
                </Typography>
              </Box>
            </Box>

            {/* Summary Cards */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={4}>
                <Card sx={{ bgcolor: "warning.light" }}>
                  <CardContent sx={{ textAlign: "center" }}>
                    <Warning sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6">Total Outstanding</Typography>
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {formatCurrencyN(totalOutstanding)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card sx={{ bgcolor: "success.light" }}>
                  <CardContent sx={{ textAlign: "center" }}>
                    <Person sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6">Customers with Pending</Typography>
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {totalCustomers}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card sx={{ bgcolor: "info.light" }}>
                  <CardContent sx={{ textAlign: "center" }}>
                    <Refresh sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6">Auto-refresh Status</Typography>
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {autoRefreshEnabled ? "Active" : "Paused"}
                    </Typography>
                    <Typography variant="caption">
                      Refreshes every 30 seconds
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Search and Actions */}
            <Paper sx={{ p: 2, mb: 2 }}>
              <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2, flexWrap: "wrap" }}>
                <TextField
                  placeholder="Search by order code, customer name, phone, or email..."
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: 300 }}
                />

                <Button
                  variant="outlined"
                  startIcon={<FilterList />}
                  onClick={() => setShowFilters(!showFilters)}
                >
                  Filters
                </Button>

                <Box sx={{ flexGrow: 1 }} />

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {isAutoRefreshing && (
                    <CircularProgress size={16} />
                  )}
                  <Typography variant="body2" color="text.secondary">
                    Showing {filteredPending.length} of {pendingTransactions.length} transactions
                    {refreshCount > 0 && ` • Auto-refreshed ${refreshCount} times`}
                  </Typography>
                </Box>
              </Box>

              {/* Filter Panel */}
              {showFilters && (
                <Box sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                      <DatePicker
                        label="Start Date"
                        value={dayjs(filters.startDate)}
                        onChange={(date) => {
                          const dateValue = date ? date.toDate() : null;
                          handleFilterChange("startDate", dateValue);
                        }}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <DatePicker
                        label="End Date"
                        value={dayjs(filters.endDate)}
                        onChange={(date) => {
                          const dateValue = date ? date.toDate() : null;
                          handleFilterChange("endDate", dateValue);
                        }}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      />
                    </Grid>
                    
                    {/* Category Filter */}
                    <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Product Category</InputLabel>
                        <Select
                          value={filters.categoryId}
                          label="Product Category"
                          onChange={(e) => handleCategoryChange(e.target.value)}
                          startAdornment={
                            <Category sx={{ mr: 1, color: "text.secondary", fontSize: 16 }} />
                          }
                        >
                          <MenuItem value="">
                            <Typography sx={{ fontWeight: 600, color: "text.secondary", fontSize: "0.9rem" }}>
                              All Categories
                            </Typography>
                          </MenuItem>
                          {categories.map((category) => (
                            <MenuItem key={category.category_id} value={category.category_id}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Category sx={{ fontSize: 16, color: "text.secondary" }} />
                                <Typography>
                                  {category.name}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Product Type Filter */}
                    {/* <Grid item xs={12} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Product Type</InputLabel>
                        <Select
                          value={filters.productType}
                          label="Product Type"
                          onChange={(e) => {
                            handleFilterChange("productType", e.target.value);
                          }}
                        >
                          <MenuItem value="">All Types</MenuItem>
                          <MenuItem value="GiftCard">Gift Card</MenuItem>
                          <MenuItem value="Crypto">Crypto</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid> */}
                    
                    <Grid item xs={12} md={2}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={clearFilters}
                        fullWidth
                      >
                        Clear Filters
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Paper>

            {/* Results Summary */}
            <Alert 
              severity="info" 
              sx={{ 
                mb: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <Box>
                Showing {filteredPending.length} of {pendingTransactions.length} pending transactions
                {filters.productType && filters.productType !== "" && (
                  <span> • Filtered by type: {filters.productType}</span>
                )}
                {filters.categoryId && filters.categoryId !== "" && (
                  <span> • Filtered by category: {
                    categories.find(c => c.category_id === filters.categoryId)?.name || filters.categoryId
                  }</span>
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress 
                  size={16} 
                  thickness={autoRefreshEnabled ? 4 : 2} 
                  color={autoRefreshEnabled ? "primary" : "inherit"}
                />
                <Typography variant="caption">
                  Auto-refresh: {autoRefreshEnabled ? "ON" : "OFF"}
                </Typography>
              </Box>
            </Alert>

            {/* SINGLE TABLE WITH CUSTOMER AND TRANSACTION DETAILS */}
            <TableContainer
              component={Paper}
              sx={{
                overflowX: "auto",
                "&::-webkit-scrollbar": {
                  height: 8,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#f1f1f1",
                  borderRadius: 4,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#c1c1c1",
                  borderRadius: 4,
                  "&:hover": {
                    backgroundColor: "#a8a8a8",
                  },
                },
              }}
            >
              <Table sx={{ minWidth: 1400 }}>
                <TableHead>
                  <TableRow sx={{ bgcolor: "grey.100" }}>
                    <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Customer</TableCell>
                    <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Order Code</TableCell>
                    <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Date</TableCell>
                    <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Product Type</TableCell>
                    <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Category</TableCell>
                    <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Payment Method</TableCell>
                    <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                      Amount Paid
                    </TableCell>
                    <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                      Outstanding
                    </TableCell>
                    <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Status</TableCell>
                    <TableCell align="center" sx={{ minWidth: 200, whiteSpace: "nowrap" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading.pending ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : filteredPending.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                        <Typography variant="body1" color="text.secondary">
                          {searchQuery ? "No transactions found matching your search" : "No pending transactions found"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <React.Fragment>
                      {filteredPending.map((transaction) => (
                        <TableRow
                          key={transaction.order_id || transaction.customer_id}
                          sx={{
                            "&:nth-of-type(even)": { bgcolor: "grey.50" },
                            "&:hover": { bgcolor: "action.hover" },
                          }}
                        >
                          {/* Customer Column */}
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Avatar
                                sx={{ bgcolor: "#e3f2fd", width: 40, height: 40, mr: 2 }}
                              >
                                <Person sx={{ fontSize: 20, color: "#1976d2" }} />
                              </Avatar>
                              <Box>
                                <Typography variant="body2" fontWeight="500">
                                  {transaction.member_name}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {transaction.customer_email || "No email"}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" display="block">
                                  {transaction.customer_phone}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>

                          {/* Order Code */}
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            <Typography variant="body2" sx={{ fontWeight: "bold", color: "primary.main" }}>
                              {transaction.order_code || "N/A"}
                            </Typography>
                          </TableCell>

                          {/* Date */}
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            <Typography variant="body2">
                              {transaction.order_date ? formatDate(transaction.order_date) : "N/A"}
                            </Typography>
                          </TableCell>

                          {/* Product Type */}
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            <Chip
                              label={transaction.product_id_type || "N/A"}
                              size="small"
                              color={
                                transaction.product_id_type === "GiftCard"
                                  ? "primary"
                                  : transaction.product_id_type === "Crypto"
                                  ? "secondary"
                                  : "default"
                              }
                            />
                          </TableCell>

                          {/* Category Column */}
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            {transaction.transaction_category ? (
                              <Chip 
                                label={categories.find(c => c.category_id === transaction.transaction_category)?.name || 
                                  transaction.transaction_category.substring(0, 8) + "..."}
                                size="small" 
                                color="primary"
                                variant="outlined"
                              />
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                N/A
                              </Typography>
                            )}
                          </TableCell>

                          {/* Payment Method */}
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            <Chip
                              label={transaction.mode_of_payment || "N/A"}
                              size="small"
                              color="secondary"
                            />
                          </TableCell>

                          {/* Amount Paid */}
                          <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                              {formatCurrency(transaction.amount_paid || "0")}
                            </Typography>
                          </TableCell>

                          {/* Outstanding */}
                          <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                color: getOutstandingColor2(Number(transaction.balance_due || 0)),
                              }}
                            >
                              {formatCurrencyN(Number(transaction.balance_due))}
                            </Typography>
                          </TableCell>

                          {/* Status */}
                          <TableCell sx={{ whiteSpace: "nowrap" }}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                              <Chip
                                label={
                                  transaction.order_status === "COMPLETED"
                                    ? "UNPAID"
                                    : transaction.order_status ?? "PENDING"
                                }
                                size="small"
                                color={getOrderStatusColor(transaction.order_status || "PENDING") as any}
                                sx={{ width: "fit-content" }}
                              />
                              {transaction.is_verified === 1 && (
                                <Chip
                                  label="Verified"
                                  size="small"
                                  color="success"
                                  sx={{ width: "fit-content" }}
                                />
                              )}
                            </Box>
                          </TableCell>

                          {/* Actions - BOTH BUTTONS */}
                          <TableCell align="center">
                            <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                              {/* Process Button */}
                              <Tooltip title="Process Customer Transactions">
                                <Button
                                  variant="outlined"
                                  size="small"
                                  startIcon={<ArrowForward />}
                                  onClick={() => handleCustomerSelect(transaction)}
                                >
                                  Process
                                </Button>
                              </Tooltip>

                              {/* Verify/View Button */}
                              <Button
                                variant="contained"
                                size="small"
                                color={Number(transaction.is_verified) === 1 ? "success" : "warning"}
                                startIcon={<Visibility />}
                                onClick={() => viewTransactionDetail(transaction)}
                              >
                                {Number(transaction.is_verified) === 1 ? "View" : "View"}
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}

                      {/* Footer with Totals */}
                      <TableRow sx={{ backgroundColor: "grey.200" }}>
                        <TableCell colSpan={6} align="right">
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            Totals
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            {formatCurrency(
                              filteredPending.reduce(
                                (sum, tx) => sum + Number(tx.amount_paid || 0),
                                0
                              )
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            {formatCurrencyN(totalOutstanding)}
                          </Typography>
                        </TableCell>
                        <TableCell colSpan={2}></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* ENHANCED VERIFICATION DIALOG - MATCHING FIRST COMPONENT */}
          {/* ... (Keep existing verify dialog code) */}

          {/* MODIFIED: Transaction Detail Dialog with Loading State - FROM SECOND COMPONENT */}
          <Dialog 
            open={showTransactionDetail} 
            onClose={closeTransactionDetail} 
            maxWidth="md" 
            fullWidth
          >
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">
                  {loadingDetails ? "Loading Order Details..." : `Order Details - ${selectedTransaction?.order_code}`}
                </Typography>
                <IconButton onClick={closeTransactionDetail}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            
            {loadingDetails && <LinearProgress />}
            
            <DialogContent dividers>
              {loadingDetails ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
                  <CircularProgress />
                  <Typography sx={{ ml: 2 }}>Fetching order breakdown...</Typography>
                </Box>
              ) : detailsError ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
                  <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
                  <Typography color="error" gutterBottom>
                    Error Loading Details
                  </Typography>
                  <Typography variant="body2" color="text.secondary" align="center">
                    {detailsError}
                  </Typography>
                  <Button 
                    variant="outlined" 
                    onClick={() => selectedTransaction && fetchOrderDetails(selectedTransaction.order_id || "", selectedTransaction.branch_id)}
                    sx={{ mt: 2 }}
                  >
                    Retry
                  </Button>
                </Box>
              ) : orderDetails ? (
                // Order Details Content - UPDATED FOR YOUR API RESPONSE
                <Grid container spacing={3}>
                  {/* Order Summary Section */}
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Order Summary
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Order ID</Typography>
                        <Typography variant="body1" fontWeight="bold">
                          {selectedTransaction?.order_id || orderDetails.items[0]?.order_id}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Order Code</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.order_code || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Customer</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.member_name || selectedTransaction?.customer_name || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Product Category</Typography>
                        <Typography variant="body1">
                          {selectedTransaction?.transaction_category ? 
                            categories.find(c => c.category_id === selectedTransaction.transaction_category)?.name || 
                            selectedTransaction.transaction_category : 
                            'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                  </Grid>

                  {/* Order Items Section */}
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Order Items ({orderDetails.items.length})
                    </Typography>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Product Name</TableCell>
                          <TableCell align="right">Qty</TableCell>
                          <TableCell align="right">Unit Price</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orderDetails.items.map((item, index) => (
                          <TableRow key={item.product_id || index}>
                            <TableCell>
                              <Typography fontWeight="medium">{item.product_name || item.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                ID: {item.product_id}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography>{item.quantity}</Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography>{formatCurrency(item.price)}</Typography>
                              {item.cost_price && (
                                <Typography variant="caption" color="text.secondary" display="block">
                                  Cost: {formatCurrency(item.cost_price)}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell align="right" fontWeight="bold">
                              <Typography>{formatCurrency(item.total_amount)}</Typography>
                              {item.cost_price && (
                                <Typography variant="caption" color="success.main" display="block">
                                  Profit: {formatCurrency((parseFloat(item.quantity) * parseFloat(item.price)) - (parseFloat(item.quantity) * parseFloat(item.cost_price)))}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={item.item_status || item.status || 'N/A'}
                                size="small"
                                color={item.item_status === 'COMPLETED' ? 'success' : 'default'}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TableCell colSpan={3}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              Totals
                            </Typography>
                          </TableCell>
                          <TableCell align="right" colSpan={3}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {formatCurrency(
                                orderDetails.items.reduce((sum, item) => sum + parseFloat(item.total_amount || "0"), 0)
                              )}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Total Quantity: {orderDetails.items.reduce((sum, item) => sum + parseFloat(item.quantity || "0"), 0)}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </Grid>

                  {/* Financial Summary Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Financial Summary
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                          <CardContent>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                              Sales Totals
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Gross Sales:</Typography>
                              <Typography fontWeight="bold">
                                {formatCurrency(
                                  orderDetails.items.reduce((sum, item) => sum + (parseFloat(item.quantity || "0") * parseFloat(item.price || "0")), 0)
                                )}
                              </Typography>
                            </Box>
                            <Divider sx={{ my: 1 }} />
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                          <CardContent>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                              Order Information
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Items Count:</Typography>
                              <Typography>{orderDetails.items.length}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Payment Method:</Typography>
                              <Chip 
                                label={selectedTransaction?.mode_of_payment || 'N/A'}
                                size="small"
                                color="secondary"
                              />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                              <Typography>Product Type:</Typography>
                              <Chip 
                                label={selectedTransaction?.product_id_type || 'N/A'}
                                size="small"
                                color="primary"
                              />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                              <Typography>Product Category:</Typography>
                              <Typography>
                                {selectedTransaction?.transaction_category ? 
                                  categories.find(c => c.category_id === selectedTransaction.transaction_category)?.name || 
                                  selectedTransaction.transaction_category : 
                                  'N/A'}
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Item Details Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                      Item Details
                    </Typography>
                    <Grid container spacing={1}>
                      {orderDetails.items.map((item, index) => (
                        <Grid item xs={12} md={6} key={item.product_id || index}>
                          <Card variant="outlined" sx={{ height: '100%' }}>
                            <CardContent>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                  {item.product_name || item.name}
                                </Typography>
                                <Chip 
                                  label={`#${index + 1}`}
                                  size="small"
                                  color="primary"
                                />
                              </Box>
                              <Typography variant="body2" color="text.secondary" paragraph>
                                {item.description || 'No description available'}
                              </Typography>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Product ID:
                                  </Typography>
                                  <Typography variant="caption" fontWeight="medium">
                                    {item.product_id?.substring(0, 12) || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Category:
                                  </Typography>
                                  <Typography variant="caption" fontWeight="medium">
                                    {item.category_id?.substring(0, 8) || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Quantity:
                                  </Typography>
                                  <Typography variant="body2">{item.quantity}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Price:
                                  </Typography>
                                  <Typography variant="body2">{formatCurrency(item.price)}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Cost Price:
                                  </Typography>
                                  <Typography variant="body2">{formatCurrency(item.cost_price || "0")}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" display="block" color="text.secondary">
                                    Profit Margin:
                                  </Typography>
                                  <Typography variant="body2" color="success.main">
                                    {formatCurrency(
                                      (parseFloat(item.quantity || "0") * parseFloat(item.price || "0")) - 
                                      (parseFloat(item.quantity || "0") * parseFloat(item.cost_price || "0"))
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Divider sx={{ my: 1 }} />
                                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="subtitle2">Total:</Typography>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                      {formatCurrency(item.total_amount)}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>

                  {/* Metadata Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="caption" color="text.secondary">
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <InfoIcon fontSize="small" />
                        <Box>
                          <div>Fetched {orderDetails.items.length} items for Order ID: {selectedTransaction?.order_id}</div>
                          <div>Transaction Type: {selectedTransaction?.product_id_type}</div>
                          <div>Product Category: {selectedTransaction?.transaction_category ? 
                            categories.find(c => c.category_id === selectedTransaction.transaction_category)?.name || 
                            selectedTransaction.transaction_category : 'N/A'}</div>
                          <div>Balance Due: {formatCurrency(selectedTransaction?.balance_due || 0)}</div>
                          <div>Amount Paid: {formatCurrency(selectedTransaction?.amount_paid || 0)}</div>
                        </Box>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Typography color="text.secondary" align="center" sx={{ p: 3 }}>
                  No order details available
                </Typography>
              )}
            </DialogContent>
            
            <DialogActions>
              <Button onClick={closeTransactionDetail}>Close</Button>
              {orderDetails && (
                <>
                  <Button 
                    variant="outlined"
                    startIcon={<Download />}
                    onClick={() => {
                      // Implement export functionality
                      const exportData = {
                        order_id: selectedTransaction?.order_id,
                        order_code: selectedTransaction?.order_code,
                        items: orderDetails.items,
                        totals: {
                          total_amount: orderDetails.items.reduce((sum, item) => sum + parseFloat(item.total_amount || "0"), 0),
                          total_quantity: orderDetails.items.reduce((sum, item) => sum + parseFloat(item.quantity || "0"), 0)
                        },
                        fetched_at: new Date().toISOString()
                      };
                      
                      const dataStr = JSON.stringify(exportData, null, 2);
                      const dataBlob = new Blob([dataStr], { type: 'application/json' });
                      const url = URL.createObjectURL(dataBlob);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = `order-details-${selectedTransaction?.order_code || selectedTransaction?.order_id}.json`;
                      link.click();
                      URL.revokeObjectURL(url);
                    }}
                  >
                    Export JSON
                  </Button>
                  <Button 
                    variant="contained" 
                    startIcon={<Receipt />}
                    onClick={() => {
                      // Implement download receipt functionality
                      console.log('Download receipt for:', selectedTransaction?.order_id);
                    }}
                  >
                    Download Receipt
                  </Button>
                </>
              )}
            </DialogActions>
          </Dialog>

          {/* Image Preview Dialog */}
          <Dialog open={imageDialogOpen} onClose={() => setImageDialogOpen(false)} maxWidth="lg" fullWidth>
            <DialogTitle>
              Image Preview
              <IconButton
                sx={{ position: "absolute", right: 8, top: 8 }}
                onClick={() => setImageDialogOpen(false)}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 400,
                }}
              >
                <img
                  src={`${baseUrl()}${selectedImage}`}
                  alt="Transaction proof"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "70vh",
                    objectFit: "contain",
                    borderRadius: 8,
                  }}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setImageDialogOpen(false)}>Close</Button>
            </DialogActions>
          </Dialog>

          {/* Snackbar for notifications */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
          />
        </IonContent>
      </IonPage>
    </LocalizationProvider>
  );
};

export default CustomerAccountPage_pending_admin_view;